import { render, staticRenderFns, recyclableRender, components } from "./release.vue?vue&type=template&id=1b929ee8&scoped=true&"
var renderjs
import script from "./release.vue?vue&type=script&lang=js&"
export * from "./release.vue?vue&type=script&lang=js&"
import style0 from "./release.vue?vue&type=style&index=0&id=1b929ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b929ee8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/square/release.vue"
export default component.exports